import React from 'react'
import styled, { keyframes } from 'styled-components'
import { transparentize } from 'polished'
import { space, mq } from 'config/theme'
import { COLORS } from 'config/constants'
import { pxToRem, scrollIntoView } from 'utils/helpers'
import { Box, Flex, Grid } from 'components/atoms/Layout'
import { Text, H3, H4, H5 } from 'components/atoms/Typography'
import Container from 'components/atoms/Container'
import Button from 'components/atoms/Button'
import stepItem1 from 'assets/images/step-item-1.svg'
import stepItem2 from 'assets/images/step-item-2.svg'
import stepItem3 from 'assets/images/step-item-3.svg'
import estate from 'assets/images/step-section-estate.svg'
import arrow from 'assets/images/button-arrow.svg'

const floatAnimation = keyframes`
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-40px);
  }
  100% {
    transform: translateY(0px);
  }
`

const StepImage = styled.img`
  flex: none;
`

const EstateImg = styled.img`
  display: block;
  max-width: ${pxToRem(500)};
  max-height: ${pxToRem(380)};
  animation: ${floatAnimation} 6s ease-in-out infinite;
  margin: 0 auto;
`

const ArrowImg = styled.img`
  margin-left: 1em;
  height: ${pxToRem(20)};
`

const DottedLine = styled.div`
  width: 1px;
  height: ${pxToRem(130)};
  background: linear-gradient(
        ${transparentize(0.5, COLORS.WHITE)} 0%,
        ${transparentize(1, COLORS.WHITE)} 50%,
        ${transparentize(0.5, COLORS.WHITE)} 100%
      )
      no-repeat center,
    linear-gradient(${COLORS.CATALAN} 50%, ${COLORS.WHITE} 0%) repeat-y center /
      1px 12px;
  margin: 0 auto;
  margin-bottom: ${space.s};
  margin-top: ${space.s};
  ${mq.from.desktop`
    position: absolute;
    top: 50%;
    left: 120%;
    width: ${pxToRem(260)};
    height: 1px;
    background: linear-gradient(
        to right,
        ${transparentize(0.5, COLORS.WHITE)} 0%,
        ${transparentize(1, COLORS.WHITE)} 50%,
        ${transparentize(0.5, COLORS.WHITE)} 100%
      ) no-repeat bottom, 
      linear-gradient(to right, ${COLORS.CATALAN} 50%, ${
    COLORS.WHITE
  } 0%) repeat-x bottom / 12px 1px;
    margin-top: 0;
    margin-bottom: 0;
  `}
`

const StepsSection = () => (
  <Container data-aos="fade-up">
    <H3 textAlign="center" fontWeight="semi_bold">
      Stop renting
    </H3>
    <H4 textAlign="center" fontWeight="normal" mt="m" mb="xl">
      It's easy to do with NuNu!
    </H4>
    <Box my="l">
      <EstateImg src={estate} />
    </Box>
    <Grid justifyItems="center">
      <Grid
        gridTemplateColumns={{ mobile: `1fr 3fr`, desktop: `1fr` }}
        gridGap="m"
      >
        <Grid
          data-aos="fade-up"
          gridTemplateRows={{ mobile: `1fr 1fr 1fr`, desktop: `1fr` }}
          gridTemplateColumns={{ mobile: `1fr`, desktop: `1fr 1fr 1fr` }}
          justifyItems="center"
        >
          <Box position={{ desktop: 'relative' }} alignItems="center">
            <StepImage src={stepItem1} alt="step-1" />
            <DottedLine />
          </Box>
          <Box position={{ desktop: 'relative' }} alignItems="center">
            <StepImage src={stepItem2} alt="step-2" />
            <DottedLine />
          </Box>
          <Box position={{ desktop: 'relative' }}>
            <StepImage src={stepItem3} alt="step-3" />
          </Box>
        </Grid>
        <Grid
          data-aos="fade-up"
          gridTemplateColumns={{ mobile: `1fr`, desktop: `1fr 1fr 1fr` }}
          textAlign={{ mobile: 'left', desktop: 'center' }}
        >
          <Box>
            <H5 fontWeight="semi_bold">GET APPROVED</H5>
            <Text mt="m">
              Follow a few simple steps and get <br />
              pre-approval now
            </Text>
          </Box>
          <Box>
            <H5 fontWeight="semi_bold">FIND A HOME</H5>
            <Text mt="m">
              Make it a reality. We will work with you <br />
              to get you into your Dream Home
            </Text>
          </Box>
          <Box>
            <H5 fontWeight="semi_bold">LIVE THE DREAM</H5>
            <Text mt="m">
              Do what you want when you want. <br />
              Start building your future today
            </Text>
          </Box>
        </Grid>
      </Grid>
    </Grid>
    <Flex justifyContent="center" my={{ desktop: 'xl' }}>
      <Button.Filled onClick={() => scrollIntoView('rent-form')}>
        WHAT CAN I AFFORD?
        <ArrowImg src={arrow} />
      </Button.Filled>
    </Flex>
  </Container>
)
export default StepsSection
